import { z } from 'zod'

import { DateTime } from '@/modules/shared/schemas/DateTime'
import { PersonaInfoSummary } from '@/modules/shared/schemas/PersonaInfoSummary'

import { TicketPriority } from './AreaPriorities'
import { SlaMetrics } from './SlaMetrics'

export const ResponsibleInfo = PersonaInfoSummary.omit({
  personaType: true
}).nullable()

export const TicketStatus = z.enum([
  'COMPLETED',
  'PENDING',
  'ANALYSIS',
  'WAITING',
  'IMPEDIMENT'
])
export type TicketStatus = z.infer<typeof TicketStatus>

export const TicketStatusFilter = z.enum(['ALL', ...TicketStatus.options])

export const Ticket = z.object({
  id: z.string(),
  ticketNumber: z.number(),
  description: z.string(),
  patient: PersonaInfoSummary.nullable(),
  complainant: PersonaInfoSummary,
  responsible: PersonaInfoSummary.nullable(),
  area: z.object({ id: z.string(), name: z.string() }),
  subArea: z.object({ id: z.string(), name: z.string() }),
  ticketAttachmentStatus: TicketStatus.nullish(),
  csat: z.number().nullish(),
  star: z.number().nullish(),
  slaConfigurations: z.array(SlaMetrics).nullish(),
  priority: TicketPriority,
  status: TicketStatus,
  createdAt: DateTime,
  updatedAt: DateTime
})
export type Ticket = z.infer<typeof Ticket>

export const CensoredTicket = Ticket.extend({
  id: Ticket.shape.id.nullable()
})
export type CensoredTicket = z.infer<typeof CensoredTicket>

export const TicketDate = z.array(
  z.object({
    date: DateTime,
    pendency: z.boolean()
  })
)

export const ListFilterTicketParam = z.object({
  page: z.number().optional(),
  size: z.number().optional(),
  month: z.number(),
  year: z.number(),
  status: TicketStatus,
  responsibleId: z.string().optional(),
  areaId: z.string().optional()
})

export type ListFilterTicketParam = z.infer<typeof ListFilterTicketParam>
export type TicketDate = z.infer<typeof TicketDate>
export const ListTickets = z.array(Ticket)
export type ListTickets = z.infer<typeof ListTickets>
export type ResponsibleInfo = z.infer<typeof ResponsibleInfo>
export const ListTicketsWithCensored = z.array(CensoredTicket)
export type ListTicketsWithCensored = z.infer<typeof ListTicketsWithCensored>
